import { LayoutPublicPages } from '@/legacy-src/layouts/LayoutPublicPages'

import useServices from '../../hooks/useServices'
import { SERVICES_TYPE } from '../../redux/DiagnosisRedux'
import TherapistList from '../therapistsList/TherapistList'
import ContentSections from './ContentSections'
import ServiceContent from './ServiceContent'

type Props = { cmsData: any }

const ServicePage: React.FC<Props> = ({ cmsData }) => {
  const { selectedService, selectedServiceId } = useServices()

  const service = cmsData?.find((item) => item.attributes.serviceId === selectedServiceId)?.attributes
  const isCounselling = selectedService?.type === SERVICES_TYPE.COUNSELLING

  return (
    <LayoutPublicPages>
      <>
        <div className="site__content mt-6">
          <div className="relative bg-body-bg">
            <ServiceContent
              showDiagnosisTeaser={!isCounselling}
              isCounselling={isCounselling}
              className="pb-6 tablet:pb-20"
              service={service}
            />
            <div className="max-w-[400px]"></div>
          </div>
        </div>
        <div className="bg-body-bg">
          {!isCounselling && (
            <div className="px-4">
              <TherapistList />
            </div>
          )}
        </div>

        <ContentSections content={service?.content} />
      </>
    </LayoutPublicPages>
  )
}

export default ServicePage
